/**
 * Utilities to detect localhost environment across server and client.
 * Used to gate unfinished features (like Guides and Docs) so they are only visible
 * during local development/previewing and hidden in production environments.
 */

export function isLocalhostHost(hostOrHostname?: string | null): boolean {
  if (!hostOrHostname) return false;
  
  let host = hostOrHostname.trim().toLowerCase();
  if (host.startsWith("[")) {
    const closingBracket = host.indexOf("]");
    if (closingBracket !== -1) {
      host = host.slice(1, closingBracket);
    }
  } else {
    const colons = host.split(":").length - 1;
    if (colons === 1) {
      host = host.split(":")[0];
    }
  }

  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "::1" ||
    host.endsWith(".localhost")
  );
}

export function isClientLocalhost(): boolean {
  if (typeof window === "undefined") {
    return process.env.NODE_ENV === "development";
  }
  return isLocalhostHost(window.location.hostname) || process.env.NODE_ENV === "development";
}
